import React from 'react';
import cx from 'classnames';
import {Image} from 'src/components/image';
import {Link} from 'src/components/link';
import {Price} from 'src/components/price';

import * as styles from './product-card.module.css';

export const ProductCard = ({product, archive}) => {
	const {
		title,
		isAntique = false,
		styledTitle,
		images,
		featured,
		slug,
		enableAcrosticCustomization,
	} = product.content.main;
	const {defaultPrice, image, defaultVariant} = product.content.shopify;

	const available =
		defaultVariant.inventoryPolicy === 'continue' ||
		defaultVariant.inventoryQuantity > 0 ||
		product?.content?.shopify?.variants?.some(
			variant =>
				variant?.content?.shopify?.inventoryQuantity > 0 ||
				variant?.content?.shopify?.inventoryPolicy === 'continue',
		);

	const priceOptions = product?.content?.shopify?.variants.map(variant => {
		return variant.content?.shopify?.price;
	});
	const uniquePriceOptions = [...new Set(priceOptions)];
	const variablePricing =
		uniquePriceOptions && uniquePriceOptions.length > 1 ? true : false;

	const mainImage = images ? images[0] : image;
	const hoverImage = (images && images.length > 1 && images[1]) || false;

	return (
		<Link
			to={`/products/${slug.current}`}
			type="internalLink"
			className={cx(
				styles.productCard,
				featured ? styles.featured : ' ',
				archive ? styles.archive : '',
			)}
		>
			<div className={styles.inner}>
				<div className={styles.imageContainer}>
					{mainImage && mainImage.asset && (
						<Image
							className={styles.mainImage}
							imageId={mainImage.asset._id}
							width={800}
							alt={mainImage.alt ? mainImage.alt : title}
							style={{height: '100%'}}
						/>
					)}

					{hoverImage && hoverImage.asset && (
						<Image
							className={styles.hoverImage}
							imageId={hoverImage.asset._id}
							width={800}
							alt={hoverImage.alt ? hoverImage.alt : title}
							style={{height: '100%'}}
						/>
					)}
				</div>
				<div className={cx(styles.details)}>
					{styledTitle && styledTitle.length ? (
						<h2 className={styles.title}>
							<span className="label-caps">
								{styledTitle[0].children[0].text}
							</span>
							<span className="default">
								{styledTitle.map(
									(segment, i) =>
										i !== 0 &&
										`${segment.children[0].text} `,
								)}
							</span>
						</h2>
					) : (
						<h2 className={styles.title}>{title}</h2>
					)}
					{!archive && (
						<h4
							className={cx(
								styles.price,
								available ? styles.available : '',
							)}
						>
							<span className="italic">
								{available ? (
									<>
										{enableAcrosticCustomization &&
											variablePricing && (
												<span>from </span>
											)}
										<Price price={defaultPrice} />
									</>
								) : (
									<span>
										{isAntique ? 'Sold!' : 'Sold Out!'}
									</span>
								)}
							</span>
						</h4>
					)}
				</div>
			</div>
		</Link>
	);
};
